import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

function Suggestion({ value, start, end, first }) {
  const part1 = value.slice(0, start);
  const part2 = value.slice(start, end);
  const part3 = value.slice(end);

  return (
    <>
      {part1}
      <strong className={'react-autosuggest__suggestion-query'}>{part2}</strong>
      <span className={clsx(first && 'react-autosuggest__suggestion-filters')}>
        {part3}
      </span>
    </>
  );
}

Suggestion.propTypes = {
  value: PropTypes.string.isRequired,
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  first: PropTypes.bool,
};

export default Suggestion;
